import { useCallback, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './sidebar.js';
import { Topbar } from './topbar.js';
import { RouteErrorBoundary } from './error-boundary.js';

/**
 * V2 admin shell — header on top, sidebar+main flex below.
 * On <880px the sidebar collapses to a hamburger-triggered drawer.
 * Route changes auto-close the drawer so navigation doesn't leave it
 * hovering over the main content.
 */
export function AppShell(): JSX.Element {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  const toggleSidebar = useCallback(() => setSidebarOpen((o) => !o), []);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--bg-page)',
      }}
    >
      <Topbar onToggleSidebar={toggleSidebar} />
      <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
        <Sidebar open={sidebarOpen} onClose={closeSidebar} />
        <main
          className="main"
          style={{
            flex: 1,
            minWidth: 0,
            overflow: 'auto',
          }}
        >
          <RouteErrorBoundary>
            <Outlet />
          </RouteErrorBoundary>
        </main>
      </div>
    </div>
  );
}
